import React, { useState, useEffect, useRef } from "react";
import { Translate } from "./LanguageChanger";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

const AudioBitratePage = ({
  onBitrateChange = (index) => console.log("Bitrate changed to index:", index),
  playerBitrates = [
    { bandwidth: 64000, active: true },
    { bandwidth: 128000, active: false },
    { bandwidth: 256000, active: false },
    { bandwidth: 512000, active: false }
  ],
  activeTrack = null,
  setShowSettings = () => {},
  currentBitrate = null,
}) => {

  console.log(currentBitrate,"currentBitrate")
  const [selectedBitrate, setSelectedBitrate] = useState(() => {
    if (currentBitrate !== null) {
      return `${playerBitrates[currentBitrate].bandwidth / 1000}Kbps`;
    } else {
      return`${
        playerBitrates.filter((item, idx) => item.active === true)[0]
          ?.bandwidth / 1000
      }Kbps`;
    }
  });
  const [focusedIndex, setFocusedIndex] = useState(currentBitrate || 0);

  const bitrateRefs = useRef([]);
  //   const bitrateOptions = ["64Kbps", "128Kbps", "256Kbps", "512Kbps"];
  const bitrateOptions = [...new Set(playerBitrates.map(
    (item) => `${item?.bandwidth / 1000}Kbps`
  ))];

   useEffect(() => {
    sendTestMatomoEvent({
      eventCategory: "(Audio)",
      eventAction: "View",
      eventName: "SelectSettingPopup",
    })
 
  },[])
  useEffect(() => {
    console.log(activeTrack);
    bitrateRefs.current[focusedIndex]?.focus(); // Focus on the current focused index
  }, []);

  const handleKeyDownAudioBitrate = (e, index) => {
    console.log(index);
    if (e.key === "ArrowDown" && index < bitrateOptions.length - 1) {
      e.preventDefault();
      const nextIndex = index + 1;
      setFocusedIndex(nextIndex);
      bitrateRefs.current[nextIndex]?.focus();
    } else if (e.key === "ArrowUp" && index > 0) {
      e.preventDefault();
      const prevIndex = index - 1;
      setFocusedIndex(prevIndex);
      bitrateRefs.current[prevIndex]?.focus();
    } else if (e.key === "Enter") {
      setSelectedBitrate(bitrateOptions[index]);
      onBitrateChange(index);
    } else if (e.key === "Back") {
      setShowSettings(false);
    }
  };

  const handleMouseEnter = (index) => {
    setFocusedIndex(index);
  };

  return (
    <div style={styles.settingsMenu} className="settings-container">
      <div style={styles.tabs}><Translate langKey={"audio_quality"}/></div>

      <div style={styles.bitrateOptions}>
        {bitrateOptions.length === 0 ? (
          <div style={styles.noDataContainer}>
            <Translate langKey={"no_data_found"} />
          </div>
        ) : (
          bitrateOptions.map((bitrate, index) => (
            <div
              key={bitrate}
              tabIndex={0}
              ref={(el) => (bitrateRefs.current[index] = el)}
              role="button"
              style={{
                ...styles.option,
                ...(focusedIndex === index ? styles.focusedOption : {}),
              // ...(selectedBitrate === bitrate ? styles.selectedOption : {}),
              }}
              onClick={() => {
                setSelectedBitrate(bitrate);
                onBitrateChange(index);
              }}
              onKeyDown={(e) => handleKeyDownAudioBitrate(e, index)}
              onMouseEnter={() => handleMouseEnter(index)}
            >
              {bitrate}
              {selectedBitrate === bitrate && (
                <span style={styles.checkmark}>✔</span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const styles = {
  settingsMenu: {
    backgroundColor: "#000037",
    opacity: "0.8",
    color: "rgb(255, 255, 255)",
    padding: "20px",
    width: "300px",
    borderRadius: "8px",
    fontFamily: "Anek Latin",
    position: "absolute",
    right: "0px",
    height: "95vh",
    opacity: 1,
  },
  tabs: {
    display: "flex",
    justifyContent: "start",
    marginBottom: "20px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  bitrateOptions: {
    display: "flex",
    flexDirection: "column",
  },
  noDataContainer: {
    backgroundColor: "#273075",
    padding: "20px",
    margin: "5px 0",
    borderRadius: "5px",
    textAlign: "center",
    fontSize: "16px",
    color: "#ffffff",
  },
  option: {
    backgroundColor: "#273075",
    padding: "12px 20px",
    margin: "5px 0",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    outline: "none",
    transition: "background 0.3s",
  },
  focusedOption: {
    backgroundColor: "#EC008C",
  },
  selectedOption: {
    backgroundColor: "#273075",
  },
  checkmark: {
    fontSize: "18px",
  },
};

export default AudioBitratePage;